import React from 'react';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

type Props = {
  isValid: boolean | null;
};

export const UiValidIconIndicator = ({ isValid }: Props) => {
  switch (isValid) {
    case true:
      return <MaterialDesignIcon iconName={ICON_NAMES.CHECK_CIRCLE} color="success" />;
    case false:
      return <MaterialDesignIcon iconName={ICON_NAMES.CANCEL} color="error" />;
    default:
      return <MaterialDesignIcon iconName={ICON_NAMES.DO_NOT_DISTURB_ON} />;
  }
};
